import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

// POS-terminal (Plan B) — admin pages inside MainLayout. The web till itself (B4) gets its own
// full-screen route outside MainLayout.
const PosHome = lazy(() => import('./pages/PosHome'));
const TerminalList = lazy(() => import('./pages/TerminalList'));
const PaymentModeList = lazy(() => import('./pages/PaymentModeList'));
const DiscountTierList = lazy(() => import('./pages/DiscountTierList'));

const posTerminalRoutes: RouteObject[] = [
  { index: true, element: <PosHome /> }, // B4: till or admin
  { path: 'admin', element: <Navigate to="terminals" replace /> },
  { path: 'admin/terminals', element: <TerminalList /> },
  { path: 'admin/payment-modes', element: <PaymentModeList /> },
  { path: 'admin/discount-tiers', element: <DiscountTierList /> },
];

export default posTerminalRoutes;
